import React from "react";
import { motion } from "framer-motion";
import { UserRound } from "lucide-react";
import { LAWYERS, OTHER_ASSOCIATED } from "./trenasData";
import TrenasLayout, { NAVY, GOLD, CREAM, SLATE } from "./TrenasLayout";

const fadeUp = { initial: { opacity: 0, y: 20 }, whileInView: { opacity: 1, y: 0 }, viewport: { once: true, margin: "-60px" }, transition: { duration: 0.5, ease: "easeOut" } };

export default function TrenasLawyers() {
  return (
    <TrenasLayout active="lawyers">
      <section className="py-16 sm:py-20" style={{ background: NAVY }}>
        <div className="max-w-3xl mx-auto px-5 sm:px-8 text-center">
          <motion.span {...fadeUp} className="text-xs uppercase tracking-[0.25em] font-semibold" style={{ color: GOLD }}>Our Lawyers</motion.span>
          <motion.h1 {...fadeUp} className="mt-4 trenas-serif text-3xl sm:text-5xl text-white">The Current Team</motion.h1>
        </div>
      </section>

      <section className="py-16" style={{ background: CREAM }}>
        <div className="max-w-5xl mx-auto px-5 sm:px-8">
          <div className="grid sm:grid-cols-2 gap-6">
            {LAWYERS.map((l, i) => (
              <motion.div key={l.name} {...fadeUp} transition={{ ...fadeUp.transition, delay: i * 0.05 }} className="bg-white rounded-lg shadow-sm overflow-hidden flex flex-col sm:flex-row">
                {l.photo ? (
                  <img src={l.photo} alt={l.name} className="w-full sm:w-32 h-40 sm:h-auto object-cover object-top" />
                ) : (
                  <div className="w-full sm:w-32 h-24 sm:h-auto flex items-center justify-center" style={{ background: "#EFE9DB" }}>
                    <UserRound size={32} style={{ color: GOLD }} />
                  </div>
                )}
                <div className="p-5">
                  <p className="trenas-serif text-lg leading-snug" style={{ color: NAVY }}>{l.name}</p>
                  <p className="mt-1 text-xs font-semibold uppercase tracking-wide" style={{ color: GOLD }}>{l.role}</p>
                  <p className="mt-2 text-xs" style={{ color: SLATE }}>{l.note}</p>
                </div>
              </motion.div>
            ))}
          </div>
          <motion.p {...fadeUp} className="mt-8 text-center text-xs max-w-xl mx-auto" style={{ color: SLATE }}>{OTHER_ASSOCIATED}</motion.p>
          <motion.div {...fadeUp} className="mt-10 max-w-2xl mx-auto flex items-center gap-5 bg-white rounded-lg p-5 shadow-sm">
            <img src="/law/trenas-law-iloilo-concept/atty-ledesma-oath.jpg" alt="Atty. Samantha S. Ledesma's oath-taking before the Philippine Supreme Court seal" className="h-24 w-24 rounded-lg object-cover shrink-0" />
            <p className="text-sm" style={{ color: SLATE }}>Atty. Samantha S. Ledesma's oath-taking, following the 2025 Bar Examinations.</p>
          </motion.div>
        </div>
      </section>
    </TrenasLayout>
  );
}
